<template>
  <div class="w-full h-full overflow-y-auto overflow-x-hidden relative">
    <el-form :model="formData" ref="cableFormRef" label-width="80px" class="mt-20px">
      <el-form-item label="电缆名称" prop="Name" :rules="[{ required: true, message: '必填' }]">
        <el-input v-model="formData.Name" size="small" placeholder=""></el-input>
      </el-form-item>
      <div class="mb-20px ml-80px">
        <el-button @click="openMode">点击绘制</el-button>
      </div>

      <el-form-item label="电缆总长" prop="Length">
        <el-input-number
          disabled
          v-model="formData.Length"
          size="small"
          placeholder=""
        ></el-input-number>
        <span class="text-[#fff] ml-10px">M </span>
      </el-form-item>
      <el-form-item label="电缆坐标" prop="position">
        <div
          class="flex"
          :class="index === formData.position.length - 1 ? '' : 'mb-20px'"
          v-for="(item, index) in formData.position"
          :key="index"
        >
          <el-row :gutter="5">
            <el-col :span="7">
              <el-form-item
                label=""
                :prop="`position[${index}].xAxial`"
                :rules="[{ required: true, validator: validatorNumber, trigger: 'blur' }]"
              >
                <el-input
                  v-model="formData.position[index].xAxial"
                  size="small"
                  placeholder=""
                  @change="posChange(index)"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item
                label=""
                :prop="`position[${index}].yAxial`"
                :rules="[{ required: true, validator: validatorNumber, trigger: 'blur' }]"
              >
                <el-input
                  v-model="formData.position[index].yAxial"
                  size="small"
                  placeholder=""
                  @change="posChange(index)"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item
                label=""
                :prop="`position[${index}].zAxial`"
                :rules="[{ required: true, validator: validatorNumber, trigger: 'blur' }]"
              >
                <el-input
                  v-model="formData.position[index].zAxial"
                  size="small"
                  placeholder=""
                  @change="posChange(index)"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <i
                class="el-icon-delete text-[#00ff00] text-[20px] cursor-pointer"
                @click="deleteItem(index)"
              ></i>
            </el-col>
          </el-row>
        </div>
      </el-form-item>
      <i
        class="el-icon-circle-plus text-[#00ff00] text-[24px] cursor-pointer ml-80px"
        @click="addItem"
      ></i>

      <div class="text-center position bottom-[20px]">
        <el-button @click="submit">保存电缆</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import DiyCodeService from '../../../service/DiyCodeService.js'
// 生成guid
const generateGUID = () => {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return guid
}
export default {
  name: 'BridgeCableDetail',
  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      defalut: () => {},
    },
  },
  data() {
    return {
      formData: {
        position: [],
        Length: 0,
        Name: '',
      },
      createMode: false,
      markPtrList: [],
      imgPtr: null,
      originPosition: [],
    }
  },
  watch: {
    transferProps: {
      async handler(val, old) {
        if (val.Id === old?.Id) return
        if (!val || !val.Id) {
          this.formData = this.$options.data().formData
        } else {
          this.formData.Length = val.Length
          this.formData.Name = val.Name

          const [err, res] = await DiyCodeService.getPipesData({
            FormEngineKey: 'diy_CablePositions',
            _Where: [
              {
                Name: 'cableId',
                Value: val.Id,
                Type: '=',
              },
            ],
          })
          if (!err && res.Code === 1) {
            this.originPosition = res.Data
            this.formData.position = res.Data.map((o) => {
              return {
                Id: o.Id,
                xAxial: o.xAxial,
                yAxial: o.yAxial,
                zAxial: o.zAxial,
              }
            })
          } else {
            this.formData.position = []
          }
        }

        await this.player.Native.GisMarker.destroy(this.markPtrList)
        await this.player.Native.Route.clearControlPoint(this.routePtr)
        this.markPtrList = []
        this.originPosition = []
        this.drawRoute()
      },
      immediate: true,
    },
  },
  methods: {
    async openMode() {
      //   this.formData.position = []
      this.createMode = true
    },
    leftCilck(data) {
      if (this.createMode) {
        this.player.Native.Route.appendControlPoint(this.routePtr, data.pos)
        this.addPos(data.pos)
      }
    },
    rightCilck() {
      this.createMode = false
    },

    async createTextMakers(name, pos) {
      if (pos.length === 4) {
        pos = pos.slice(1)
      }
      const nameLength = name.length
      const textRows = Math.ceil((nameLength * 15) / 160)
      const imgHeight = textRows * 15 + 10
      const option = {
        localTrans: pos, // 定位点，世界坐标，三维向量
        nodeOffset: [0, 0], // 相对定位点的偏移量，二维向量
        imgId: this.imgPtr, // 图片id
        imgSize: [textRows > 1 ? 160 : nameLength * 15, imgHeight || 30], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
        text: name || '', // 文本
        textFontSize: 15.0, // 字体大小
        breakWidth: 160, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
        textColor: 0xffffffff, // 文本颜色
        title: null, // 标题
        contentPadding: [5, 5, 5, 5],
      }

      this.player.Native.GisMarker.create(option, (markerId) => {
        this.markPtrList.push(markerId)
      })
    },
    addPos(val, flag = false) {
      // flag 标识是否为手动创建
      if (flag) {
        if (this.formData.position.length === 1) {
          this.createTextMakers('开始', val)
        } else {
          const distance = this.computeDistance(
            this.formData.position[this.formData.position.length - 2],
            this.formData.position[this.formData.position.length - 1]
          )
          this.formData.Length = this.formData.Length + distance
          this.createTextMakers(`${distance} M`, val)
        }
        return
      }
      if (this.formData.position.length !== 0) {
        const distance = this.computeDistance(
          this.formData.position[this.formData.position.length - 1],
          {
            xAxial: val[0],
            yAxial: val[1],
            zAxial: val[2],
          }
        )
        this.formData.Length = this.formData.Length + distance
        this.createTextMakers(`${distance} M`, val)
      } else {
        this.createTextMakers('开始', val)
      }
      this.formData.position.push({
        xAxial: val[0],
        yAxial: val[1],
        zAxial: val[2],
      })
    },
    getImageSize(name) {
      const nameLength = name.length
      const textRows = Math.ceil((nameLength * 15) / 160)
      const imgHeight = textRows * 15 + 10
      return {
        imgSize: [textRows > 1 ? 160 : nameLength * 15, imgHeight || 30],
      }
    },
    validatorNumber(rule, value, callback) {
      if (!value) {
        return callback(new Error('必填'))
      }
      const pattern = /^[+-]?\d+(\.\d+)?$/
      if (pattern.test(value)) {
        return callback()
      }
      return callback(new Error('类型错误'))
    },
    async deleteItem(index) {
      // 删除对应序列的控制点和标签
      this.formData.position.splice(index, 1)
      this.player.Native.Route.removeControlPoint(this.routePtr, index)
      this.player.Native.GisMarker.destroy(this.markPtrList[index])
      this.markPtrList.splice(index, 1)
      // 起始点变更
      if (index === 0) {
        this.player.Native.GisMarker.setProperty(this.markPtrList[index], {
          text: '开始',
          ...this.getImageSize('开始'),
        })
      } else {
        // 重新计算序列后的距离
        const distance = this.computeDistance(
          this.formData.position[index],
          this.formData.position[index - 1]
        )
        // 若只存在一个控制点变更起始点
        const text = distance == null ? '开始' : `${distance} M`
        this.player.Native.GisMarker.setProperty(this.markPtrList[index], {
          text,
          ...this.getImageSize(text),
        })
      }

      this.computeSum()
    },
    addItem() {
      this.formData.position.push({
        xAxial: null,
        yAxial: null,
        zAxial: null,
      })
    },
    async posChange(index) {
      let pos = Object.values(this.formData.position[index])
      pos.length === 4 ? (pos = pos.slice(1)) : null
      const isEffect = pos.every((o) => {
        return o || o == 0
      })
      // 需判定坐标是否有效
      if (!isEffect) {
        return
      }

      const controlPoints = await this.player.Native.Route.controlPointCount(this.routePtr)
      // 判定控制点是否是手动添加
      if (controlPoints < this.formData.position.length) {
        this.player.Native.Route.appendControlPoint(this.routePtr, pos)
        this.addPos(pos, true)
        return
      }
      // 处理控制点位置变动，非创建类型
      this.player.Native.Route.resetControlPoint(this.routePtr, index, pos)
      this.player.Native.GisMarker.setProperty(this.markPtrList[index], { localTrans: pos })
      // 处理序列前的距离
      if (index !== 0) {
        const distance = this.computeDistance(
          this.formData.position[index],
          this.formData.position[index - 1]
        )
        this.player.Native.GisMarker.setProperty(this.markPtrList[index], {
          text: `${distance} M`,
          ...this.getImageSize(`${distance} M`),
        })
      }
      // 处理序列后的距离
      if (index !== this.formData.position.length - 1) {
        const distance = this.computeDistance(
          this.formData.position[index],
          this.formData.position[index + 1]
        )
        this.player.Native.GisMarker.setProperty(this.markPtrList[index + 1], {
          text: `${distance} M`,
          ...this.getImageSize(`${distance} M`),
        })
      }
      this.computeSum()
    },
    computeSum() {
      this.formData.Length = 0
      for (let index = 0; index < this.formData.position.length - 1; index++) {
        const distance = this.computeDistance(
          this.formData.position[index],
          this.formData.position[index + 1]
        )
        this.formData.Length = this.formData.Length + distance
      }
    },
    computeDistance(pos1, pos2) {
      if (!pos1 || !pos2) return null
      const dx = pos1.xAxial - pos2.xAxial
      const dy = pos1.yAxial - pos2.yAxial
      const dz = pos1.zAxial - pos2.zAxial
      return Math.sqrt(dx * dx + dy * dy + dz * dz)
    },
    async update() {
      const param = {
        FormEngineKey: 'diy_Cable',
        Id: this.transferProps.Id,
        _RowModel: {
          Name: this.formData.Name,
          Length: this.formData.Length,
          Points: this.formData.position.length,
        },
      }
      const [err, res] = await DiyCodeService.uptFormData(param)
      if (!err && res.Code === 1) {
        let err1 = null
        let res1 = null
        const params = this.formData.position
          .filter((e) => {
            return e.Id
          })
          .map((o) => {
            return {
              FormEngineKey: 'diy_CablePositions',
              Id: o.Id,
              _RowModel: {
                xAxial: o.xAxial,
                yAxial: o.yAxial,
                zAxial: o.zAxial,
              },
            }
          })
        if (params && params.length !== 0) {
          ;[err1, res1] = await DiyCodeService.UptFormDataBatch(params)
        }
        const addParams = this.formData.position
          .filter((e) => {
            return !e.Id
          })
          .map((o) => {
            return {
              FormEngineKey: 'diy_CablePositions',
              _RowModel: {
                cableId: this.transferProps.Id,
                ...o,
              },
            }
          })

        if (addParams && addParams.length !== 0) {
          ;[err1, res1] = await DiyCodeService.AddDiyTableRowBatch(addParams)
        }

        // 处理原始数据有删除
        const list = _.differenceBy(this.originPosition, this.formData.position, 'Id')
        if (list && list.length !== 0) {
          const delparam = list.map((o) => {
            return {
              FormEngineKey: 'diy_CablePositions',
              Id: o.Id,
            }
          })
          console.log(list, 'list===========');
          [err1, res1] = await DiyCodeService.DelDiyTableRowBatch(delparam)
        }

        return [err1, res1]
      }
      return [err, res]
    },
    async add(Id) {
      const param = {
        FormEngineKey: 'diy_Cable',
        Id,
        _FormData: {
          Id,
          Name: this.formData.Name,
          Length: this.formData.Length,
          Points: this.formData.position.length,
        },
      }

      const [err, res] = await DiyCodeService.addFormData(param)
      if (!err && res.Code === 1) {
        const params = this.formData.position.map((o) => {
          return {
            FormEngineKey: 'diy_CablePositions',
            _RowModel: {
              cableId: res.Data.Id,
              ...o,
            },
          }
        })
        if (params && params.length !== 0) {
          const [err1, res1] = await DiyCodeService.AddDiyTableRowBatch(params)
          return [err1, res1]
        }
        return [err, res]
      }
      return [err, res]
    },
    async submit() {
      await this.$refs.cableFormRef.validate()
      let err = null
      let res = null
      const Id = generateGUID()
      if (this.transferProps?.Id) {
        ;[err, res] = await this.update()
      } else {
        ;[err, res] = await this.add(Id)
      }
      if (!err && res.Code === 1) {
        this.$message.success('保存成功！')
        this.$emit('closeComponent', {
          code: 'BridgeCableDetail',
          origin: 'business',
        })
        this.$emit('transferEvent', {
          type: 'transferData',
          code: 'NewBridgeCable',
          data: { Id: this.transferProps?.Id ? this.transferProps?.Id : Id },
        })
      }
    },
    async drawRoute() {
      for (let index = 0; index < this.formData.position.length; index++) {
        if (index === 0) {
          this.createTextMakers('开始', Object.values(this.formData.position[index]))
        } else {
          const distance = this.computeDistance(
            this.formData.position[index],
            this.formData.position[index - 1]
          )
          this.createTextMakers(`${distance} M`, Object.values(this.formData.position[index]))
        }
      }
      const pos = Object.values(this.formData.position).map((o) => {
        return Object.values(o).slice(1)
      })

      await this.player.Native.Route.appendControlPoint(this.routePtr, pos)
    },
  },
  async mounted() {
    this.player.Native.Tools.EventBrowseLClick.connect(this.leftCilck)
    this.player.Native.Tools.EventBrowseRClick.connect(this.rightCilck)
    this.imgPtr = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,135')
    this.routePtr = await this.player.Native.Route.create(0)
    this.player.Native.Route.setProperty(this.routePtr, { lineWidth: 10 })
  },
  async beforeDestroy() {
    await this.player.Native.Route.destroy(this.routePtr)

    await this.player.Native.GisMarker.destroy(this.markPtrList)
    const routes = await this.player.Native.Route.getAllRoute()
    await this.player.Native.Route.setProperty(
      routes.map((o) => {
        return {
          route: o,
          props: {
            pointVisible: true,
            lineVisible: true,
          },
        }
      })
    )
    const markers = await this.player.Native.GisMarker.getMarkerList()
    console.log(markers, 'markers-------')

    await this.player.Native.GisMarker.setProperty(
      markers
        .map((o) => {
          return o.id
        })
        .flat(),
      {
        visible: true,
      }
    )
    this.player.Native.Tools.EventBrowseLClick.disconnect(this.leftCilck)
    this.player.Native.Tools.EventBrowseRClick.disconnect(this.rightCilck)
  },
}
</script>

<style lang="scss" scoped>
.el-button {
  color: #fff !important;
}
</style>
